module.exports = "<span class=\"kl-timepicker {class}\" r-hide={!visible}>\n\t<number-input min=\"0\" max=\"23\" format=\"00\" value={hour} readonly={readonly} disabled={disabled || disabledHours} autofocus={autofocus} />\n\t<span>:</span>\n\t<number-input min=\"0\" max=\"59\" format=\"00\" value={minute} readonly={readonly} disabled={disabled || disabledMinutes} />\n\t<span>:</span>\n\t<number-input min=\"0\" max=\"59\" format=\"00\" value={seconds} readonly={readonly} disabled={disabled || disabledSeconds} />\n</span>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLDatePicker/TimePicker/index.html
// module id = 356
// module chunks = 0